import React from "react";
import Routers from "./Components/Routers/Routers";
import AuthButton from "./AuthButton";
import { connect } from "react-redux";
import { MoonLoader } from "react-spinners";
import Login from "./Components/Pages/Login";

function App({ UserId, userType }) {
  if (!UserId || !userType) {
    return <Login />;
  }

  return (
    <>
      {/* Restore loader to avoid null errors */}
      <div id="tmoverlay" className="d-none">
        <div className="w-100 h-100 d-flex align-items-center justify-content-center">
          <MoonLoader size={50} color="#1b67b3" />
        </div>
      </div>

      <Routers />
    </>
  );
}

const mapStateToProps = (state) => ({
  menuVisibility: state.menuVisibility,
  menuStatusHeader: state.menuStatusHeader,
  getToken: state.token,
  userType: state.userType,
  userName: state.userName,
  UserId: state.UserId,
});

export default connect(mapStateToProps)(App);
